if (!customElements.get('db-announce')) {
  customElements.define(
    'db-announce',
    class DbAnnounce extends HTMLElement {
      connectedCallback() {
        this.messages = Array.from(this.querySelectorAll('.db-announce__msg'));
        if (this.messages.length < 2) return;
        this.index = 0;
        this.interval = parseInt(this.dataset.interval, 10) || 5000;
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      start() {
        this.stop();
        this.timer = setInterval(() => this.next(), this.interval);
      }

      stop() {
        clearInterval(this.timer);
      }

      next() {
        const current = this.messages[this.index];
        this.index = (this.index + 1) % this.messages.length;
        const upcoming = this.messages[this.index];
        current.classList.remove('is-active');
        current.setAttribute('aria-hidden', 'true');
        upcoming.classList.add('is-active');
        upcoming.removeAttribute('aria-hidden');
      }
    }
  );
}
